// The one place the site draws icons: Lucide outline icons (lucide-react, pinned), looked up
// by a short stable name so callers never import Lucide directly. Only the icons named below
// are imported, so the bundle carries just these.
//
// Props: size (16 beside small text, 20 in buttons and rows, 24 as a lead icon), color
// (currentColor by default), strokeWidth (1.75 for every icon so the set looks even), filled
// (fills the shape with the icon color -- the selected state of star and bookmark), label.
// Decorative by default (aria-hidden); pass `label` when the icon itself carries meaning and
// it is exposed as an image with that accessible name. Icon-only buttons put their own
// aria-label (and aria-pressed for toggles) on the button.
import {
  Bell, Bookmark, Briefcase, Building, Building2, Calendar, Camera, ChartColumn, Check, CircleCheck,
  CircleHelp, CircleX, ClipboardList, DollarSign, FileText, Flame, Globe, GraduationCap, Handshake,
  HardHat, Info, Link, Lock, Mail, MapPin, Megaphone, MessageSquare, PenLine, Phone, RefreshCw,
  Search, ShieldCheck, Sparkles, Star, Tag, Target, TrendingDown, TrendingUp, TriangleAlert, Users,
  Video, Wrench, X,
} from 'lucide-react';

const AMBER = '#F5A623';

const ICONS = {
  search: Search,
  briefcase: Briefcase,
  message: MessageSquare,
  checkCircle: CircleCheck,
  clipboard: ClipboardList,
  target: Target,
  signature: PenLine,
  city: Building2,
  wrench: Wrench,
  graduation: GraduationCap,
  building: Building,
  bell: Bell,
  calendar: Calendar,
  dollar: DollarSign,
  users: Users,
  trendingDown: TrendingDown,
  globe: Globe,
  tag: Tag,
  barChart: ChartColumn,
  megaphone: Megaphone,
  hardHat: HardHat,
  handshake: Handshake,
  link: Link,
  check: Check,
  x: X,
  warning: TriangleAlert,
  help: CircleHelp,
  star: Star,
  flame: Flame,
  bookmark: Bookmark,
  mapPin: MapPin,
  refresh: RefreshCw,
  phone: Phone,
  envelope: Mail,
  lock: Lock,
  info: Info,
  document: FileText,
  camera: Camera,
  video: Video,
  trendingUp: TrendingUp,
  shieldCheck: ShieldCheck,
  sparkle: Sparkles,
  xCircle: CircleX,
};

export default function LineIcon({ name, size = 20, color = 'currentColor', strokeWidth = 1.75, filled = false, label, style }) {
  const Icon = ICONS[name];
  if (!Icon) return null;
  const a11y = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true, focusable: 'false' };
  return (
    <Icon size={size} color={color} strokeWidth={strokeWidth} fill={filled ? color : 'none'} {...a11y}
      style={{ flexShrink: 0, display: 'block', ...style }}>
      {label && <title>{label}</title>}
    </Icon>
  );
}

// A 44px rounded square with a soft amber tint and an amber icon centered in it -- the lead
// icon on feature cards.
export function IconTile({ name, size = 24, style }) {
  return (
    <div aria-hidden="true" style={{
      width: '44px', height: '44px', borderRadius: '10px', flexShrink: 0,
      backgroundColor: 'rgba(245,166,35,0.14)', color: AMBER,
      display: 'flex', alignItems: 'center', justifyContent: 'center', ...style,
    }}>
      <LineIcon name={name} size={size} />
    </div>
  );
}
